<template>
  <Tile
    class="document-tile"
    :class="{ [`document-tile--${size}`]: size }"
    :focusable="focusable"
    :selected="selected"
    :disabled="disabled"
    @click="$emit('click', $event)"
  >
    <div class="document-tile-info">
      <b-icon class="document-tile-icon" :icon="icon" size="is-medium" />
      <div class="document-tile-description">
        <div class="document-tile-label">{{ label }}</div>
        <div class="document-tile-status">
          <slot name="status">
            {{ status }}
          </slot>
        </div>
      </div>
    </div>
    <slot name="action"></slot>
  </Tile>
</template>

<script>
import Tile from "@/shared_components/Tile";
import { PresetDocumentLabelIcons } from "@/constants/presetDocumentLabels";
import DateTimeMixin from "@/mixins/dateTime";

export default {
  components: {
    Tile
  },
  mixins: [DateTimeMixin],
  props: {
    document: {
      type: Object,
      default: null
    },
    presetLabel: {
      type: String,
      default: null
    },
    focusable: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    label() {
      return this.document ? this.document.label : this.presetLabel;
    },
    status() {
      return this.document
        ? `Submitted on ${this.getDateTime(this.document.created_at)}`
        : "Not yet provided";
    },
    icon() {
      return PresetDocumentLabelIcons[this.label] || "file";
    }
  }
};
</script>

<style scoped lang="scss">
@import "bulma/sass/utilities/mixins.sass";
@import "@/scss/colors.scss";

.document-tile {
  justify-content: space-between;
  padding: 10px 20px;
  @include mobile {
    padding: 5px 10px;
  }
  &-info {
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
  }
  &-icon {
    margin-right: 15px;
  }
  &-description {
    display: flex;
    flex-direction: column;
  }
  &-label {
    font-size: 16px;
    @include mobile {
      font-size: 14px;
    }
  }
  &-status {
    color: rgba(#000, 0.5);
    font-size: 12px;
  }
  &--is-small {
    padding: 5px 10px;
  }
}
</style>
